
import { createContext, useContext, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import styles from '../../../css/StaffMgmt.module.css';
import titleStyle from '../../../css/SectionTitle.module.css';
import { BsList } from "react-icons/bs";
import { MenuContext } from "../DashBoard";
import { ResultContext } from "./ResultMgmt";
import AddResultGroup from "./AddResultGroup";
import ViewResultGroup from "./ViewResultGroup";

const ResultGroup = ()=>{
    const {showMenu, setShowMenu} = useContext(MenuContext);
    const {title} = useContext(ResultContext)
    return (

            <div className={`${styles.baseView}`} style={{ display: 'flex', flexWrap: 'wrap' }}>
                <h1 className={`${styles.title}`}>Result Group</h1>
                <div className={`${styles.subView}`}>
                    <div className={titleStyle.sectionTitle}>
                        <h3 className={titleStyle.h3}>
                            {title}
                        </h3>
                        <div className={`${titleStyle.menuDiv}`}>
                            <span className={`${titleStyle.menuBtn}`} onClick={() => setShowMenu(!showMenu)}><BsList />Menu</span>
                            {showMenu &&
                                <div className={`${titleStyle.subMenu}`} >
                                    <ul>
                                        <li><Link to='add-result-group'>Add Result Group</Link></li>
                                        <li><Link to='view-result-group'>View Result Group</Link></li> 
                                    
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    
                    
                    <Routes>
                        {/* <Route element={<ViewResultGroup />} path={'/view-result-group'} />*/}
                        <Route element={<AddResultGroup />} path={'/add-result-group'} />
                        <Route element={<ViewResultGroup />} path={'/view-result-group'} />
                        <Route element={<ViewResultGroup/>} path={'/*'} />
                    </Routes>
                </div>
            </div>
    );
}
export default ResultGroup;